import { useTranslation } from 'react-i18next';

const ClientReviewSummary = ({ review, onEdit }) => {
  const { t } = useTranslation();

  return (
    <div className="mt-3 rounded-lg border border-amber-800/30 bg-amber-950/15 p-3">
      <p className="text-xs text-amber-400">
        {t('client.history.youRated', { rating: review.rating })}
      </p>
      {review.comment && (
        <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-400">{review.comment}</p>
      )}
      <p className="mt-2 text-[11px] text-zinc-500">
        {review.isVisible ? t('reviews.statusPublished') : t('reviews.statusPendingPublish')}
      </p>
      <button
        type="button"
        onClick={onEdit}
        className="mt-2 text-xs text-glow-400 hover:underline"
      >
        {t('reviews.editReview')}
      </button>
    </div>
  );
};

export default ClientReviewSummary;
